// extracted by mini-css-extract-plugin
module.exports = {"live-icon":"mobileTopMenuLive__live-icon___eQ39_"};